import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { useClientFetch } from '~/composables/useClientFetch.js';
import {useUserStore} from "~/stores/UserStore.js";
import {useModal} from "~/stores/ModalStore.js";
import WatchlistCreateAccountModal from "~/components/Modals/WatchlistCreateAccountModal.vue";
import {gtm} from '~/composables/gtm.js';

export const useWatchlistStore = defineStore('watchlist', () => {
    const products = ref([]);
    const count = computed(() => products.value.length);

    function initData(data) {
        products.value = data;
    }

    async function toggleProduct(id) {
        if (!useUserStore().isLoggedIn()) {
            useModal().openModal('WatchlistCreateAccountModal', WatchlistCreateAccountModal);
            return;
        }
        if (hasProduct(id)) {
            await useClientFetch(`user/watchlist/${id}`, {
                method: 'DELETE'
            }).then(response => {
                if (response.success) {
                    products.value = products.value.filter(item => item.id !== id);
                }
            });
        } else {
            await useClientFetch('user/watchlist', {
                method: 'POST',
                body: { product_id: id }
            }).then(response => {
                if (response.success) {
                    products.value.push({ id: id, quantity: 1 });

                    //update dataLayer
                    if (response && 'dataLayer' in response.data) {
                        gtm.push(response.data.dataLayer);
                    }
                }
            });
        }
    }

    function hasProduct(id) {
        return products.value.findIndex(item => item.id === id) >= 0;
    }

    function remove(id) {
        products.value = products.value.filter(item => item.id !== id);
    }

    return {
        products,
        count,
        initData,
        toggleProduct,
        hasProduct,
        remove,
    };
});
